import { apiConfig } from "./apiConfig";

const detailIdUrl = `${apiConfig.base}/oftheday/`;
const detailPostUrl = apiConfig.oftheday.detail;
const relatedPostsUrl = apiConfig.oftheday.related;

// export const getDetailPostById = (axios, id) => axios.get(`${detailIdUrl}${id}`);
export const getDetailPost = (axios, id, slug) =>
  !slug ? axios.get(`${detailIdUrl}${id}`) : axios.get(`${detailPostUrl}?otd_slug=${slug}`);
export const getRelatedPosts = (axios, id) => axios.get(`${relatedPostsUrl}/${id}`);
